import { jsxs as h, jsx as r } from "react/jsx-runtime";
import { c as e } from "../clsx-OuTLNxxd.js";
import { Icon as m } from "../Icon/Icon.js";
import { c as p } from "../background-CRdXfOz5.js";
const u = "DiscountChip-module_chip__tUmZH",
  a = "DiscountChip-module_with-line-through__qzrdX",
  l = "DiscountChip-module_icon__0zYIT",
  i = {
    chip: u,
    withLineThrough: a,
    icon: l
  },
  x = _ref => {
    let {
      children: o,
      className: c,
      background: s,
      lineThrough: n
    } = _ref;
    const t = p(s);
    return /* @__PURE__ */h("div", {
      className: e(i.chip, t, c, {
        [i.withLineThrough]: n
      }),
      children: [/* @__PURE__ */r(m, {
        name: "discount-chip",
        size: "1x",
        padding: !1,
        className: i.icon
      }), o]
    });
  };
export { x as DiscountChip };